// Copyright (c) 2022-2024. Sendanor <info@sendanor.fi>. All rights reserved.

import { ReactNode } from "react";
import { CARD_LIST_CLASS_NAME } from "../../../../core/constants/className";
import { map } from "../../../../../../io/hyperify/core/functions/map";
import { ProductModel } from "../../../../../../io/hyperify/core/store/types/product/ProductModel";
import { CardItem } from "./CardItem";
import { T_PRODUCT_LIST_NO_ITEMS } from "../../../../core/constants/translation";
import { ButtonStyle } from "../../../../../../io/hyperify/core/frontend/button/ButtonStyle";
import { TranslationFunction } from "../../../../../../io/hyperify/core/types/TranslationFunction";
import "./CardList.scss";

export interface CardListProps {
  readonly t            : TranslationFunction;
  readonly className   ?: string;
  readonly buttonLabel ?: string;
  readonly productList  : readonly ProductModel[];
  readonly dark        ?: boolean;
  readonly children    ?: ReactNode;
}

export function CardList (props: CardListProps) {
  const t = props?.t;
  const className   : string | undefined = props?.className;
  const children    : ReactNode | undefined = props?.children;
  const dark        : boolean = props?.dark ?? false;
  const buttonLabel : string | undefined = props?.buttonLabel;
  const productList : readonly ProductModel[] = props?.productList ?? [];
  return (
    <div className={
      CARD_LIST_CLASS_NAME
      + (className ? ` ${className}` : "")
      + (dark?' '+CARD_LIST_CLASS_NAME+'-dark': '')
    }>
      {productList?.length ? (
          <>
            <div className={CARD_LIST_CLASS_NAME+'-children'}>
              { productList?.length >= 2 ? children : null }
            </div>

            {map(productList, (item: ProductModel, i) => {
              return (
                  <CardItem
                      key={`${item.id}-${item.title}-`+i}
                      className={CARD_LIST_CLASS_NAME+'-item'}
                      buttonLabel={item?.buttonLabel ?? buttonLabel}
                      buttonRoute={item?.route}
                      buttonStyle={item?.buttonStyle ?? ButtonStyle.PRIMARY}
                      icon={item?.icon}
                      title={item?.title}
                      description={item?.description}
                      product={item?.product}
                      productPrice={item?.productPrice}
                      dark={dark}
                  >{ productList?.length < 2 ? children : null }</CardItem>
              );
            })}
          </>
      ) : (
        <article className={CARD_LIST_CLASS_NAME+"-no-results"}>
          <p>{t(T_PRODUCT_LIST_NO_ITEMS)}</p>
        </article>
      )}
    </div>
  );
}
